// extracted by mini-css-extract-plugin
module.exports = {"player_html":"styles_player_html__5nQ7q","player_html__document":"styles_player_html__document__3dMTe"};